class ExpandableBlock extends HTMLElement {
	constructor() {
		super();

		const shadow = this.attachShadow({mode: 'open'});

		this.moreLabel = this.getAttribute('more-label') || 'See more';
		this.lessLabel = this.getAttribute('less-label') || 'See less';

		shadow.innerHTML = /* HTML */`
			<style>
				:host {
					display: block;
				}

				.slot {
					--max-height: var(--max-height-mobile, auto);
					max-height: var(--max-height);
					overflow: hidden;
					transition: max-height 250ms;
				}

				@media (min-width: 992px) {
					.slot {
						--max-height: var(--max-height-desktop, auto);
					}
				}

				:host([expanded]) .slot {
					max-height: max(var(--max-height), var(--height, auto));
				}

				button {
					font: inherit;
					color: var(--color-text-tertiary);
					font-size: 14px;
					width: 100%;
					border: none;
					background: none;
					z-index: 1;
					display: flex;
					align-items: center;
					justify-content: center;
					gap: 4px;
					cursor: pointer;
					background: white;
					padding: 8px;
					position: relative;
				}

				button::before {
					position: absolute;
					content: '';
					bottom: 100%;
					left: 0;
					right: 0;
					height: 32px;
					background: linear-gradient(transparent, white);
					pointer-events: none;
					transition: opacity 250ms;
				}

				:host([expanded]) button::before {
					opacity: 0;
				}

				button::after {
					content: '';
					display: block;
					width: 16px;
					height: 16px;
					background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 8H8M12 8H8M8 8V4M8 8V12' stroke='%23212121' stroke-width='0.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
				}

				:host([expanded]) button::after {
					background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 8H12' stroke='%23212121' stroke-width='0.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
				}

				.no-expand + button {
					display: none;
				}
			</style>

			<div>
				<div class="slot">
					<div class="content">
						<slot></slot>
					</div>
				</div>
				<button>${this.moreLabel}</button>
			</div>
		`;

		this.button = shadow.querySelector('button');
		this.slotElem = shadow.querySelector('.slot');
		this.content = shadow.querySelector('.content');

		const observer = new ResizeObserver(() => {
			this.slotElem.style.setProperty('--height', `${this.slotElem.scrollHeight - 1}px`);
			this.slotElem.classList.toggle('no-expand', this.slotElem.scrollHeight == this.slotElem.clientHeight);
		});

		observer.observe(this.content);

		this.button.addEventListener('click', () => {
			if (this.hasAttribute('expanded')) {
				this.removeAttribute('expanded');
				this.button.textContent = this.moreLabel;
			}
			else {
				this.setAttribute('expanded', '');
				this.button.textContent = this.lessLabel;
			}
		});

	}
}

customElements.define('expandable-block', ExpandableBlock);